// import axios from "axios";
import moment from "moment";
import axios from "../modules/axios";

//axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
//axios.defaults.headers.common["Content-Type"] = "application/json";
// axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
// 	"token"
// )}`;
// 로그인

// get from session (if the value expired it is destroyed)
//export function sessionGet(key) {
//	let stringValue = window.sessionStorage.getItem(key)
//	if (stringValue !== null) {
//		let value = JSON.parse(stringValue)
//		let expirationDate = new Date(value.expirationDate)
//		if (expirationDate > new Date()) {
//			return value.value
//		} else {
//			window.sessionStorage.removeItem(key)

//			// 다 지워주기
//			window.localStorage.removeItem("token");
//			window.localStorage.removeItem("user");
//			window.localStorage.removeItem("userNo");
//			window.localStorage.removeItem("userId");
//			window.localStorage.removeItem("userRole");
//		}
//	}
//	return null
//}

//// add into session
//export function sessionSet(key, value, expirationInMin = 30) {
//	let expirationDate = new Date(new Date().getTime() + (60000 * expirationInMin))
//	let newValue = {
//		value: value,
//		expirationDate: expirationDate.toISOString()
//	}
//	window.sessionStorage.setItem(key, JSON.stringify(newValue))
//}

export function localGet(key) {
  let stringValue = window.localStorage.getItem(key);
  let expirationDate = window.localStorage.getItem("expirationDate");

  if (stringValue !== null) {
    if (new Date(expirationDate) > new Date()) {
      return stringValue;
    } else {
      // 다 지워주기
      localDel();
    }
  }
  return null;
}

export function localExpDateSet(expirationInMin = 30) {
  let expirationDate = new Date(new Date().getTime() + 60000 * expirationInMin);
  window.localStorage.setItem("expirationDate", expirationDate.toISOString());
}

export function localDel(key = "") {
  if (key != "") {
    window.localStorage.removeItem(key);
  } else {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("userNo");
    window.localStorage.removeItem("userId");
    window.localStorage.removeItem("userRole");
    window.localStorage.removeItem("expirationDate");
    window.localStorage.removeItem("botAdminId");
    window.localStorage.removeItem("botAdminNo");
  }
}

axios.interceptors.request.use(
  function(config) {
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers["Content-Type"] = "application/json";

    if (
      !config.url.includes("/user/signIn/") &&
      !config.url.includes("/user/findPwd/") &&
      !config.url.includes("/user/findLoginId") &&
      !config.url.includes("/user/signUp/") &&
      !config.url.includes("/user/idCheck/") &&
      config.data === undefined &&
      // 소개 페이지에서 문의를 등록할 경우
      !(
        config.data !== undefined &&
        config.data.memberType !== undefined &&
        config.data.memberType == "none"
      ) &&
      (localGet("token") === undefined ||
        localGet("token") === "" ||
        localGet("token") === null)
    ) {
      //전체 다 삭제
      localDel();

      window.location.href = "/auth/login";
      alert("세션이 만료 되었거나 유효하지 않은 요청입니다.");
    } else {
      //시간 연장
      localExpDateSet();
    }

    return config;
  },
  function(error) {
    console.log(error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    //response.data 가 undefined인 경우 backend 서버가 내려갔거나 연동이 꼬일수 있으므로 재로그인 시킴
    if (
      response.data === undefined ||
      (response.data.code !== undefined &&
        (response.data.code == 901 || response.data.code == 902))
    ) {
      //전체 다 삭제
      localDel();

      window.location.href = "/auth/login";
      alert("세션이 만료 되었거나 유효하지 않은 요청입니다.");
    } else {
      return response;
    }
  },
  function(error) {
    return Promise.reject(error);
  }
);

export async function getLogin(params, value) {
  // console.log("params", params);
  try {
    delete axios.defaults.headers.common["Authorization"];
    const response = await axios.post("/user/signIn/" + value, params);
    // console.log(response);
    if (response.status === 200) {
      localExpDateSet();
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    console.log("login-setHeader fail");
    console.log("e", e);
  }
}

export async function goSignUp(params, value) {
  // console.log("params", params);
  console.log(value);
  try {
    delete axios.defaults.headers.common["Authorization"];
    const response = await axios.post("/user/signUp/" + value, params);
    // console.log(response);
    if (response.status === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    console.log("login-setHeader fail");
    console.log("e", e);
  }
}

export const getFindPwd = async (value) => {
  try {
    delete axios.defaults.headers.common["Authorization"];
    const response = await axios.get("/user/findPwd/" + value);
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getMyLicenseList = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/myList", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getSysLicenseList = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/list", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotAdminLicenseList = async (value) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/botAdmin/" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const uptLicense = async (id, body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.put("/license/" + id, body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const deleteBotAdmin = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.put("/user/manage/del", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const updateBotAdmin = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.put("/user/manage/status", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const resetPass = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.put("/user/manage/pwd", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const updateBuyHistory = async (id, body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.put("/license/payment/" + id, body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const getLicenseReqList = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/contact/list", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getLicenseBuyList = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/payment/myList", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getLicenseSysBuyList = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/payment/list", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getDetailContact = async (value) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/contact/" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getNoticeList = async (value) => {
  const accessToken = await localStorage.getItem("token");
  if (value === undefined) {
    value = "";
  }
  try {
    const response = await axios.get("/notice/list?searchWord=" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getNoticeAllList = async () => {
  const accessToken = await localStorage.getItem("token");

  try {
    const response = await axios.get("/notice/listAll", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotMonitoring = async (value) => {
  const accessToken = await localStorage.getItem("token");
  if (value === undefined) {
    value = "";
  }
  try {
    const response = await axios.get("/bot/monitoring?userNo=" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getSchedule = async (stDate, edDate) => {
  const accessToken = await localStorage.getItem("token");

  console.log("accessToken", accessToken);
  try {
    const response = await axios.get(
      "/schedule/list?stDate=" + stDate + "&edDate=" + edDate,
      {
        headers: {
          Authorization: "Bearer " + `${accessToken}`,
        },
      }
    );
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getSchedule1 = async (stDate, edDate, value) => {
  const accessToken = await localStorage.getItem("token");

  try {
    const response = await axios.get(
      "/schedule/list?stDate=" +
        stDate +
        "&edDate=" +
        edDate +
        "&userNo=" +
        value,
      {
        headers: {
          Authorization: "Bearer " + `${accessToken}`,
        },
      }
    );
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getNoticeDetail = async (value) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/notice/" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getMain = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/main", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getMainSys = async (value) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/main?userNo=" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotRate = async (startAt, endAt, value) => {
  if (value === undefined) {
    value = "";
  }
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get(
      "/exeHistory/execRate?startAt=" +
        startAt +
        "&endAt=" +
        endAt +
        "&botAdminId=" +
        value,
      {
        headers: {
          Authorization: "Bearer " + `${accessToken}`,
        },
      }
    );
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotWeeklyResult = async (startAt, endAt, value) => {
  if (value === undefined) {
    value = "";
  }
  endAt = moment(endAt)
    .add(1, "days")
    .format("YYYY-MM-DD");
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get(
      "/main/exeCount?stDate=" +
        startAt +
        "&edDate=" +
        endAt +
        "&userNo=" +
        value,
      {
        headers: {
          Authorization: "Bearer " + `${accessToken}`,
        },
      }
    );
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotScheduleResult = async (startAt, endAt, value) => {
  if (value === undefined) {
    value = "";
  }

  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get(
      "/main/scheduleExeCount?stDate=" +
        startAt +
        "&edDate=" +
        endAt +
        "&userNo=" +
        value,
      {
        headers: {
          Authorization: "Bearer " + `${accessToken}`,
        },
      }
    );
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotWeekly = async (startAt, endAt, value) => {
  if (value === undefined) {
    value = "";
  }
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get(
      "/exeHistory/list?startAt=" +
        startAt +
        "&endAt=" +
        endAt +
        "&botAdminId=" +
        value,
      {
        headers: {
          Authorization: "Bearer " + `${accessToken}`,
        },
      }
    );
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const insertNotice = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.post("/notice", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const copyBook = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.post("/book/copy", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const insertLicense = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.post("/license", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const insertBuyHistory = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.post("/license/payment", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const insertReq = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.post("/contact", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const insertBot = async (body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.post("/bot", body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const updateBot = async (id, body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.put("/bot/" + id, body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const updateContact = async (id, body) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.put("/contact/" + id, body, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status === 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const deleteNotice = async (id) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.delete("/notice/" + id, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status == 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const deleteLicense = async (id) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.delete("/license/" + id, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status == 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const deleteBuyHistory = async (id) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.delete("/license/payment/" + id, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status == 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const deleteReqHistory = async (id) => {
  const accessToken = await localStorage.getItem("token");
  const response = await axios.delete("/contact/" + id, {
    headers: {
      Authorization: "Bearer " + `${accessToken}`,
    },
  });
  console.log(response.status);
  if (response.status == 200) {
    return response.data;
  } else {
    throw response.data;
  }
};

export const updateNotice = async (id, body) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.put("/notice/" + id, body, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    // console.log(response);
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const updateBookName = async (id, body) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.put("/book/" + id, body, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    console.log("response", response.data);
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const updateBotStatus = async (body) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.put("/bot/manage/status", body, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    // console.log(response);
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const deleteBotStatus = async (value) => {
  // console.log("value", value);
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.put("/bot/manage/del", value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    // console.log(response);
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const deleteBook = async (value) => {
  // console.log("value", value);
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.delete("/book/" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    // console.log(response);
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getLicenseList = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/list", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBookDetail = async (value) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/book/" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const findLicenseNumber = async (value) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/list?searchWord=" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getLicenseDetail = async (value) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBuyDetail = async (value) => {
  console.log("vavavav", value);
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/payment/" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const createLicenseKey = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/license/licenseNumber", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const findLoginId = async (value) => {
  if (value === undefined) {
    value = "";
  }
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get(
      "/user/botAdmin/list?searchWord=" + value,
      {
        headers: {
          Authorization: "Bearer " + `${accessToken}`,
        },
      }
    );
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const dupleCheckBotId = async (value) => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/bot/idCheck/" + value, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotList = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/bot/myBotList", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status === 200 && response.data.code === 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getFindUserId = async (value) => {
  try {
    delete axios.defaults.headers.common["Authorization"];
    const response = await axios.get(
      "/user/findLoginId?name=" +
        value.userName +
        "&nationNum=" +
        value.nationNum +
        "&phone=" +
        value.phoneNumber
    );
    if (response.status == 200 && response.data.code == 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotAdminList = async () => {
  try {
    delete axios.defaults.headers.common["Authorization"];
    const response = await axios.get("/user/botAdmin/list");
    if (response.status == 200 && response.data.code == 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotAdminList1 = async () => {
  const accessToken = await localStorage.getItem("token");
  try {
    const response = await axios.get("/user/botAdmin/list", {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status == 200 && response.data.code == 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotBookList = async (id) => {
  const accessToken = await localStorage.getItem("token");
  console.log(id);
  try {
    const response = await axios.get(`/book/list?userNo=${id}`, {
      headers: {
        Authorization: "Bearer " + `${accessToken}`,
      },
    });
    if (response.status == 200 && response.data.code == 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getDupleEmail = async (email) => {
  try {
    const response = await axios.get(`/user/idCheck/${email}`);
    if (response.status == 200 && response.data.code == 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};

export const getBotAdmin = async (botId) => {
  try {
    const response = await axios.get(`/bot/getBotAdmin/${botId}`);
    if (response.status == 200 && response.data.code == 200) {
      return response.data;
    } else {
      throw response.data;
    }
  } catch (e) {
    return e;
  }
};
